import { createFileRoute } from "@tanstack/react-router";
import PrivacyPage from "@/pages/PrivacyPage";
import { pageHead } from "@/lib/site";

export const Route = createFileRoute("/privacy-policy")({
  head: () =>
    pageHead(
      "Privacy Policy | Scotty's Land Specialist",
      "Privacy Policy for Scotty's Land Specialist LLC, explaining how we collect, use, store, and protect your personal information.",
      "/privacy-policy",
    ),
  component: PrivacyPage,
});
